import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IDeviceFormat } from 'legacy/lut/features/partner360/shareOfBusiness/models'

type TMapPartner360DevicesFormatToApi = {
  a3: IDeviceFormat
  a4: IDeviceFormat
}

export const mapPartner360DeviceFormatToApiFields = (
  devicesFormat: TMapPartner360DevicesFormatToApi
): Partial<I621Form> => {
  const { a3, a4 } = devicesFormat

  return {
    A3HP: a3.hpBrand,
    A3AllBrands: a3.allBrands,
    A3TopVendorBrand1: a3.topVendorBrand1.name,
    A3TopVendorBrand1Spend: a3.topVendorBrand1.spend,
    A3TopVendorBrand2: a3.topVendorBrand2.name,
    A3TopVendorBrand2Spend: a3.topVendorBrand2.spend,
    A3TopVendorBrand3: a3.topVendorBrand3.name,
    A3TopVendorBrand3Spend: a3.topVendorBrand3.spend,
    A3TopVendorBrandOtherSpend: a3.otherBrandSpend,
    PrevUnitsA3: a3.previousUnits,

    A4HP: a4.hpBrand,
    A4AllBrands: a4.allBrands,
    A4TopVendorBrand1: a4.topVendorBrand1.name,
    A4TopVendorBrand1Spend: a4.topVendorBrand1.spend,
    A4TopVendorBrand2: a4.topVendorBrand2.name,
    A4TopVendorBrand2Spend: a4.topVendorBrand2.spend,
    A4TopVendorBrand3: a4.topVendorBrand3.name,
    A4TopVendorBrand3Spend: a4.topVendorBrand3.spend,
    A4TopVendorBrandOtherSpend: a4.otherBrandSpend,
    PrevUnitsA4: a4.previousUnits,
  }
}
